var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepository(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.933333C0 0.417868 0.417868 0 0.933333 0H23.5822C23.8298 0 24.0672 0.098333 24.2422 0.273367L27.7266 3.75781C27.9017 3.93285 28 4.17024 28 4.41778V19.1333C28 19.6488 27.5821 20.0667 27.0667 20.0667C26.5512 20.0667 26.1333 19.6488 26.1333 19.1333V4.80438L23.1956 1.86667H1.86667V26.1333H11.2C11.7155 26.1333 12.1333 26.5512 12.1333 27.0667C12.1333 27.5821 11.7155 28 11.2 28H0.933333C0.417868 28 0 27.5821 0 27.0667V0.933333Z",
    fill: "#58486C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8396 0C22.355 0 22.7729 0.417868 22.7729 0.933333V5.22667H27.0662C27.5817 5.22667 27.9996 5.64453 27.9996 6.16C27.9996 6.67547 27.5817 7.09333 27.0662 7.09333H21.8396C21.3241 7.09333 20.9062 6.67547 20.9062 6.16V0.933333C20.9062 0.417868 21.3241 0 21.8396 0Z",
    fill: "#58486C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1333 12.1333C15.2673 12.1333 12.1333 15.2673 12.1333 19.1333C12.1333 22.9993 15.2673 26.1333 19.1333 26.1333C22.9993 26.1333 26.1333 22.9993 26.1333 19.1333C26.1333 18.6178 26.5511 18.1999 27.0666 18.1999C27.5821 18.1999 27.9999 18.6178 27.9999 19.1333C27.9999 24.0302 24.0302 27.9999 19.1333 27.9999C14.2363 27.9999 10.2666 24.0302 10.2666 19.1333C10.2666 14.2363 14.2363 10.2666 19.1333 10.2666C19.6487 10.2666 20.0666 10.6845 20.0666 11.1999C20.0666 11.7154 19.6487 12.1333 19.1333 12.1333Z",
    fill: "#58486C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1766 10.4932C21.5522 10.8462 21.5705 11.4369 21.2174 11.8125L19.4093 13.7359C19.0562 14.1115 18.4655 14.1297 18.09 13.7766C17.7144 13.4236 17.6961 12.8329 18.0492 12.4573L19.2181 11.2139L17.9747 10.0451C17.5991 9.69203 17.5809 9.10136 17.9339 8.72578C18.287 8.35021 18.8776 8.33196 19.2532 8.68502L21.1766 10.4932Z",
    fill: "#58486C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6671 15.8662C18.1516 15.8662 17.7338 16.2841 17.7338 16.7995V20.5329C17.7338 20.8563 17.9013 21.1568 18.1764 21.3268C18.4516 21.4969 18.7952 21.5123 19.0845 21.3677L22.8178 19.501C23.2789 19.2705 23.4658 18.7099 23.2352 18.2488C23.0047 17.7878 22.4441 17.6009 21.983 17.8314L19.6004 19.0227V16.7995C19.6004 16.2841 19.1826 15.8662 18.6671 15.8662Z",
    fill: "#58486C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7334 5.60033C3.7334 5.08486 4.15127 4.66699 4.66673 4.66699H14.9334C15.4489 4.66699 15.8667 5.08486 15.8667 5.60033C15.8667 6.11579 15.4489 6.53366 14.9334 6.53366H4.66673C4.15127 6.53366 3.7334 6.11579 3.7334 5.60033Z",
    fill: "#58486C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7334 9.33372C3.7334 8.81826 4.15127 8.40039 4.66673 8.40039H10.2667C10.7822 8.40039 11.2001 8.81826 11.2001 9.33372C11.2001 9.84919 10.7822 10.2671 10.2667 10.2671H4.66673C4.15127 10.2671 3.7334 9.84919 3.7334 9.33372Z",
    fill: "#58486C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepository);
export default __webpack_public_path__ + "static/media/repository.b7127335dd82ee81fed32c62f455a879.svg";
export { ForwardRef as ReactComponent };